<template>
  <div class="footer-page-container">
    <div class="page-content">
      <h1 class="page-title">关于我们</h1>
      <div class="page-body">
        <section class="about-intro">
          <h2>公司简介</h2>
          <p>英才计划是国内领先的职业教育培训机构，专注于为学员提供高质量的教育资源和个性化的学习解决方案。自成立以来，我们始终秉承"以学员为中心，以质量为根本"的办学理念，致力于培养具有实践能力和创新精神的专业人才。</p>
          <p>我们拥有一支由行业专家、资深讲师组成的教学团队，开发了一系列符合市场需求的精品课程，涵盖职业技能培训、学历提升、资格认证等多个领域。凭借专业的教学内容、先进的教学方法和完善的服务体系，我们已帮助数以万计的学员实现了职业发展目标。</p>
        </section>
        
        <section class="about-mission" style="margin-top: 30px;">
          <h2>使命愿景</h2>
          <div class="mission-vision">
            <div class="mission-item">
              <h3>我们的使命</h3>
              <p>提供优质教育资源，助力学员职业发展，推动行业进步</p>
            </div>
            <div class="mission-item">
              <h3>我们的愿景</h3>
              <p>成为国内最具影响力的职业教育品牌，让每个人都能通过学习改变命运</p>
            </div>
          </div>
        </section>
        
        <section class="about-values" style="margin-top: 30px;">
          <h2>核心价值观</h2>
          <div class="values-grid">
            <div class="value-item">
              <h3>学员至上</h3>
              <p>始终把学员的需求和利益放在首位，提供个性化的学习体验</p>
            </div>
            <div class="value-item">
              <h3>专业务实</h3>
              <p>专注于教学质量，追求专业、实用、高效的教学效果</p>
            </div>
            <div class="value-item">
              <h3>创新进取</h3>
              <p>不断创新教学方法和内容，适应行业发展和市场需求</p>
            </div>
            <div class="value-item">
              <h3>诚信负责</h3>
              <p>坚持诚信办学，对学员负责，对社会负责</p>
            </div>
          </div>
        </section>
        
        <section class="about-contact" style="margin-top: 30px;">
          <h2>联系我们</h2>
          <div class="contact-info">
            <p><strong>公司地址：</strong>北京市朝阳区建国路88号</p>
            <p><strong>联系电话：</strong>400-100-0000</p>
            <p><strong>电子邮箱：</strong>contact@yingcaijihua.com</p>
            <p><strong>工作时间：</strong>周一至周日 9:00-21:00</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      // 页面数据
    }
  },
  methods: {
    // 页面方法
  }
}
</script>

<style scoped lang="scss">
.footer-page-container {
  max-width: 1200px;
  margin: 100px auto 0;
  padding: 40px 20px;
}

.page-content {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #3E2CCD;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.page-body {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  
  p {
    margin-bottom: 15px;
  }
}
</style>